/* tslint:disable */
/* eslint-disable */
export enum SolutionAimEnum {
  AIM_FIRST_TIME_BUYING = 'Aim_FirstTimeBuying',
  AIM_REPLACE_EXISTING = 'Aim_ReplaceExisting',
  AIM_CONSIDER_REPLACE_EXISTING = 'Aim_ConsiderReplaceExisting'
}
